import { render } from "./siteDetail.vue?vue&type=template&id=2cb6c256&scoped=true"
import script from "./siteDetail.vue?vue&type=script&lang=js"
export * from "./siteDetail.vue?vue&type=script&lang=js"

import "./siteDetail.vue?vue&type=style&index=0&id=2cb6c256&scoped=true&lang=less"

import exportComponent from "D:\\web\\my\\水茶花\\sch-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb6c256"]])

export default __exports__